<div class="data-filter">
    <label [i18n]="labelKey"></label>
    <input type="text"
           class="form-control"
           [ngModel]="displayModel"
           [i18n]="[{target: 'attribute:placeholder', key: placeholderKey}]"
           [disabled]="disabled"
           (ngModelChange)="onNgChange($event)">
</div>
